import Home from '@/app/views/home.vue'
import AGB from '@/app/views/agb.vue'
import DSGVO from '@/app/views/dsgvo.vue'
import FAQ from '@/app/views/faq.vue'
import About from '@/app/views/about.vue'
import Impressum from '@/app/views/impressum.vue'
import Tenants from '@/tenants/views/tenants.vue'
import EmailConfirm from '@/users/views/email-confirm.vue'
import Login from '@/users/views/login.vue'
import Permissions from '@/users/views/permissions.vue'
import Register from '@/users/views/register.vue'
import SetPassword from '@/users/views/set-password.vue'
import ResetPassword from '@/users/views/reset-password.vue'
import Settings from '@/users/views/settings.vue'
import Users from '@/users/views/users.vue'
import Error from '@/app/views/error.vue'

import Clients from '@/clients/views/clients.vue'

export default {
  // Default route the user will be redirected to if none is specified in the
  // request params.
  loginDefaultRedirect: {
    ADMIN: 'home',
    TENANT: 'home',
    USER: 'home',
    DEFAULT: 'home',
  },

  // Route to redirect to after a successful logout.
  logoutRedirect: 'login',

  routes: [
    //-------------------------------------------------------------------------
    // Project-independent routes.
    //-------------------------------------------------------------------------
    {
      path: '/:lang?',
      name: 'default',
      component: Home,
      meta: {
        layout: 'sidebar-layout',
        title: 'Home',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/home',
      name: 'home',
      component: Home,
      meta: {
        layout: 'sidebar-layout',
        title: 'Home',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/agb',
      name: 'agb',
      component: AGB,
      meta: {
        layout: 'sidebar-layout',
      },
    },
    {
      path: '/:lang?/faq',
      name: 'faq',
      component: FAQ,
      meta: {
        layout: 'sidebar-layout',
      },
    },
    {
      path: '/:lang?/about',
      name: 'about',
      component: About,
      meta: {
        layout: 'sidebar-layout',
      },
    },
    {
      path: '/:lang?/dsgvo',
      name: 'dsvgo',
      component: DSGVO,
      meta: {
        layout: 'sidebar-layout',
      },
    },
    {
      path: '/:lang?/impressum',
      name: 'impressum',
      component: Impressum,
      meta: {
        layout: 'sidebar-layout',
      },
    },
    {
      path: '/:lang?/:user/email-confirm/:token',
      name: 'email-confirm',
      component: EmailConfirm,
      props: true,
      meta: {
        layout: 'empty-layout',
      },
    },
    {
      path: '/:lang?/login/:redirectUrl?',
      name: 'login',
      component: Login,
      meta: {
        layout: 'header-layout',
      },
    },
    {
      path: '/:lang?/register',
      name: 'register',
      component: Register,
      meta: {
        layout: 'header-layout',
      },
    },
    {
      path: '/:lang?/:email/set-password/:token',
      name: 'set-password',
      component: SetPassword,
      props: true,
      meta: {
        layout: 'empty-layout',
      },
    },
    {
      path: '/:lang?/:email/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword,
      props: true,
      meta: {
        layout: 'empty-layout',
      },
    },
    {
      path: '/:lang?/settings',
      name: 'settings',
      component: Settings,
      meta: {
        layout: 'sidebar-layout',
        title: 'Einstellungen',
        requiresAuth: true,
      },
    },
    {
      path: '/:lang?/users',
      name: 'users',
      component: Users,
      meta: {
        layout: 'sidebar-layout',
        title: 'Benutzer',
        requiresAuth: true,
        roles: ['ADMIN', 'TENANT'],
      },
    },
    {
      path: '/:lang?/tenants',
      name: 'tenants',
      component: Tenants,
      meta: {
        layout: 'sidebar-layout',
        title: 'Mandanten',
        requiresAuth: true,
        roles: ['ADMIN'],
      },
    },
    {
      path: '/:lang?/permissions',
      name: 'permissions',
      component: Permissions,
      meta: {
        layout: 'sidebar-layout',
        title: 'Berechtigungen',
        requiresAuth: true,
        roles: ['ADMIN'],
      },
    },

    //-------------------------------------------------------------------------
    // Project-based routes.
    //-------------------------------------------------------------------------
    {
      path: '/:lang?/clients',
      name: 'clients',
      component: Clients,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        title: 'Client Configs',
        requiresAuth: true,
        roles: ['ADMIN'],
      },
    },

    //-------------------------------------------------------------------------
    // Error page.
    //-------------------------------------------------------------------------
    {
      path: '/error/:status',
      name: 'error',
      component: Error,
      meta: {
        layout: 'empty-layout',
      },
    },

    // Fallback redirect.
    { path: '*', redirect: '/error/404' },
  ],
}
